export function normalizeUserRole(role?: string | null): string {
  return (role || "").trim().toLowerCase();
}

export function isStaffRole(role?: string | null): boolean {
  const normalized = normalizeUserRole(role);
  return (
    normalized === "admin" ||
    normalized === "dev" ||
    normalized === "owner" ||
    normalized === "admindev"
  );
}

export function isMemberRole(role?: string | null): boolean {
  return normalizeUserRole(role) === "member";
}
